export const summaryRows: string[] = [
  'Volume 01 — Diesel Engine Fundamentals: The Four-Stroke Cycle, Combustion & Core Engine Components',
  'Volume 02 — Diesel Fuel Systems: Fuel Quality, Storage, Filtration, Injection Pumps, Injectors & Common Rail',
  'Volume 03 — Engine Support Systems: Lubrication, Cooling, Air Intake, Exhaust & Turbocharging',
  'Volume 04 — Diesel Generator Sets: Alternators, Voltage & Speed Regulation, Paralleling & Automatic Transfer',
  'Volume 05 — Diesel Engine & Genset Maintenance and Diagnostics: Preventive Maintenance, Condition Monitoring & Typical Failures',
  'Volume 06 — Safe Operation, Load Testing & Generator Fleet Management',
  'Bonus 1 — Diesel Engine Troubleshooting Visual Guide',
  'Bonus 2 — Generator Set Start-Up, Run & Shutdown Visual Guide',
  'Bonus 3 — Diesel Fuel Storage & Fuel Quality Field Guide',
  'Bonus 4 — Oil & Coolant Analysis Interpretation Guide',
  'Bonus 5 — Diesel Engines & Generators Terminology Dictionary',
  '7-day money-back guarantee',
  'Instant access',
];
